import { useRef } from 'react';

const CARD_W = 240;
const CARD_H = 160;
const MARGE = 8;

const useLabelSmartPosition = (x, y) => {
  const ref = useRef(null);

  const vw = window.innerWidth;
  const vh = window.innerHeight;

  let left = x + 14;
  let top  = y - 24;

  if (left + CARD_W > vw - MARGE) left = x - CARD_W - 8;
  if (left < MARGE) left = MARGE;
  if (top + CARD_H > vh - MARGE) top = vh - CARD_H - MARGE;
  if (top < MARGE) top = MARGE;

  return { ref, pos: { left, top, visibility: 'visible' } };
};

export default useLabelSmartPosition;
